import React from "react";
import "./Ourwork.css";

const DEG = randInt(360);
const FLEX = false;

const LIST = [...Array(11).keys()].map((e) => {
  return `https://picsum.photos/125?${randInt()}`;
});

function Ourwork() {
  const [index, setIndex] = React.useState();
  const [list, setList] = React.useState([...LIST]);
  const btn = React.useRef();

  function handleUpload(e) {
    if (typeof btn === "object" && btn !== null) {
      const { current } = btn;
      if (typeof current === "object" && current !== null) {
        current.click();
      }
    }
  }

  function handleChange(e) {
    e.preventDefault();
    setList([...list, URL.createObjectURL(e.target.files[0])]);
  }

  return (
    <FlexContainer deg={DEG} flex={FLEX}>
      <div className="bkg">
        <div className="h1 text-center text-white text-shadow titleSize">
          OUR <b>MAGICAL WORKS</b>
        </div>
        <div>
          <div className="moa">
            {list.map((e, i) => {
              return (
                <div>
                  <div>
                    <img
                      key={i}
                      src={e}
                      style={{ minWidth: "150px", objectFit: "contain" }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-center mt-6 addBtn">
            <button className="btn btn-sm shadow" onClick={handleUpload}>
              Add More
            </button>
            <input
              className="d-none"
              type="file"
              ref={btn}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </FlexContainer>
  );
}

function FlexContainer(props) {
  const { children, deg = randInt(360), bg } = props;
  return <div>{children}</div>;
}

function randInt(n = 10) {
  return Math.floor(Math.random() * n);
}

export default Ourwork;
